const footerNav = [
  {
    title: '快速导航',
    links: [
      { label: '首页', href: '#hero' },
      { label: '关于我们', href: '#about' },
      { label: '核心优势', href: '#features' },
      { label: '常见问题', href: '#faq' },
    ],
  },
  {
    title: '内容中心',
    links: [
      { label: '专题索引', href: '#index' },
      { label: '最新动态', href: '#updates' },
      { label: '热门话题', href: '#topics' },
      { label: '热播榜单', href: '#ranking' },
    ],
  },
  {
    title: '用户服务',
    links: [
      { label: 'APP下载', href: '#app' },
      { label: '用户评价', href: '#comments' },
      { label: '联系我们', href: '#contact' },
      { label: '焦点推荐', href: '#carousel' },
    ],
  },
];

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-white">
      <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 py-12 md:py-16">
          <div className="lg:col-span-2">
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); handleClick('#hero'); }}
              className="font-heading text-xl font-bold mb-4 inline-block cursor-pointer"
            >
              91精品影视
            </a>
            <p className="text-sm text-white/50 leading-relaxed mt-3 max-w-sm">
              91精品影视 — 专业高清影视看片平台。提供91影视看片APP官方版下载安装，海量高清影视资源，每日实时更新，安全可靠。覆盖电影、电视剧、综艺、动漫、纪录片等全品类内容，支持Android和iOS双平台。
            </p>
          </div>

          {footerNav.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-sm font-semibold mb-4 text-white/80">{col.title}</h3>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); handleClick(link.href); }}
                      className="text-sm text-white/40 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/10 py-8">
          <div className="mb-6">
            <h3 className="text-sm font-semibold text-white/60 mb-3">合作伙伴</h3>
            <p className="text-xs text-white/25">
              合作伙伴信息持续更新中，欢迎优质内容方与技术伙伴与我们建立合作。
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-white/30">
              &copy; 2019-2026 91精品影视. All rights reserved.
            </p>
            <div className="flex items-center gap-4 text-xs text-white/30">
              <span>91影视看片APP官方下载</span>
              <span className="text-white/10">|</span>
              <span>安全认证 · 正版保障</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}